var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigUserscomponent = function SvgWorkspaceBigUserscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#FE9A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.992 13a2.247 2.247 0 1 1-4.492 0 2.247 2.247 0 1 1 4.492 0Zm5.25 1.125A1.87 1.87 0 0 1 19.375 16a1.876 1.876 0 0 1 0-3.75 1.87 1.87 0 0 1 1.867 1.875ZM19.375 17.5c-1.372 0-4.125.69-4.125 2.063v1.687h8.25v-1.688c0-1.372-2.753-2.062-4.125-2.062ZM8.5 19.375c0-1.747 3.502-2.625 5.25-2.625.495 0 1.125.075 1.777.21-1.53.848-1.777 1.965-1.777 2.602v1.688H8.5v-1.875Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceBigUserscomponent;